import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UtrederLogin from './pages/UtrederLogin';
import UtrederRegister from './pages/UtrederRegister';
import UtrederDashboard from './pages/UtrederDashboard';
import MicrositeEditor from './pages/MicrositeEditor';
import MottatteSaker from './pages/MottatteSaker'; // Import new page
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  if (!isAuthenticated || user?.role !== 'utreder') {
    return <Navigate to="/utreder/login" />;
  }
  return children;
};

const UtrederModule = () => {
  return (
    <Routes>
      <Route path="login" element={<UtrederLogin />} />
      <Route path="register" element={<UtrederRegister />} />
      <Route path="dashboard" element={
        <ProtectedRoute>
          <UtrederDashboard />
        </ProtectedRoute>
      } />
      <Route path="microsite" element={
        <ProtectedRoute>
          <MicrositeEditor />
        </ProtectedRoute>
      } />
      <Route path="mottatte-saker" element={
        <ProtectedRoute>
          <MottatteSaker />
        </ProtectedRoute>
      } />
      <Route path="/" element={<Navigate to="login" />} />
    </Routes>
  );
};

export default UtrederModule;